interface IProps {
    phone: string;
    offerName?: string;
    propertyNumber?: string;
}

export const GetPhoneApplicationMessage = (props: IProps) => {
    return `Klient prosił o rozmowę telefoniczną na numer ${props.phone} dotyczącą ${props.propertyNumber ? `nieruchomości ${props.propertyNumber} w inwestycji ${props.offerName}` : `inwestycji ${props.offerName}`}.`;
};
interface IProps {
    phone: string;
    offerName?: string;
    propertyNumber?: string;
}

export const GetPhoneApplicationMessage = (props: IProps) => {
    return `Klient prosił o rozmowę telefoniczną na numer ${props.phone} dotyczącą ${props.propertyNumber ? `nieruchomości ${props.propertyNumber} w inwestycji ${props.offerName}` : `inwestycji ${props.offerName}`}.`;
};
